import { EnergyYearData } from 'app/types/visualizations';
import ServicePieChart from 'app/components/charts/ServicePieChart';

interface EmissionsByServiceProps {
  sortedYears: EnergyYearData[];
}

const ENERGY_COLORS = {
  steam: '#5B8DEF', // Muted Blue ( #5B8DEF)
  gas: '#E8A355', // Muted Amber ( #E8A355)
  electric: '#3DAB94', // Muted Emerald ( #3DAB94)
  oil: '#8588E8', // Muted Indigo ( #8588E8)
  water: '#7FB3F5', // Muted Light Blue ( #7FB3F5)
};

const EmissionsByService = ({ sortedYears }: EmissionsByServiceProps) => {
  // Transform data for the emissions chart
  const chartData = sortedYears.map((year) => ({
    year: new Date(year.startDate).getFullYear(),
    electric: year.energyUsageTotalsByService.electric?.emissions ?? 0,
    gas: year.energyUsageTotalsByService.gas?.emissions ?? 0,
    steam: year.energyUsageTotalsByService.steam?.emissions ?? 0,
    oil: year.energyUsageTotalsByService.oil?.emissions ?? 0,
    water: year.energyUsageTotalsByService.water?.emissions ?? 0,
    emissionsThreshold: year.threshold,
  }));

  // Get current year data for pie chart
  const currentYearData = chartData[chartData.length - 1];
  const total = Object.entries(currentYearData || {})
    .filter(([key]) => !['year', 'emissionsThreshold', 'water'].includes(key))
    .reduce((sum, [, value]) => sum + (value || 0), 0);

  const pieChartData = [
    { name: 'Electric', value: currentYearData?.electric || 0 },
    { name: 'Gas', value: currentYearData?.gas || 0 },
    { name: 'Steam', value: currentYearData?.steam || 0 },
    { name: 'Oil', value: currentYearData?.oil || 0 },
  ]
    .filter((item) => item.value > 0)
    .map((item) => ({
      ...item,
      percentage: ((item.value / total) * 100).toFixed(1),
      color: ENERGY_COLORS[item.name.toLowerCase()],
    }));

  return (
    <ServicePieChart data={pieChartData} colorMap={ENERGY_COLORS} title="Emissions by Service" valueUnit="tCO₂e" />
  );
};

export default EmissionsByService;
